import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/ui/tabs';
import { Button } from 'components/ui/button';
import { FiChevronLeft } from 'react-icons/fi';
import PrintQueueViewer from '../../components/PrintQueue/PrintQueueViewer';
import RicohTestPage from '../../components/PrintQueue/RicohTestPage';
import PrinterStatusMonitor from '../../components/PrintQueue/PrinterStatusMonitor';
import PrintingSettings from '../../components/PrintQueue/PrintingSettings';
import SiteWrapper from '../../containers/SiteWrapper';

const PrintingPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const leftTopBarButton = (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleGoBack}
      className="flex items-center gap-2"
    >
      <FiChevronLeft size={16} />
      Retour
    </Button>
  );

  return (
    <SiteWrapper
      title="Service d'impression"
      leftTopBarButton={leftTopBarButton}
    >
      <div className="container mx-auto p-6">
        <div className="mb-6">
          <p className="text-muted-foreground">
            Gestion de la file d'impression et test de l'imprimante Ricoh
          </p>
        </div>

        <Tabs defaultValue="queue" className="w-full">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="queue">File d'impression</TabsTrigger>
            <TabsTrigger value="test">Test imprimante</TabsTrigger>
            <TabsTrigger value="status">Statut imprimante</TabsTrigger>
            <TabsTrigger value="settings">Paramètres</TabsTrigger>
          </TabsList>
          
          <TabsContent value="queue" className="mt-6">
            <PrintQueueViewer />
          </TabsContent>
          
          <TabsContent value="test" className="mt-6">
            <RicohTestPage />
          </TabsContent>
          
          <TabsContent value="status" className="mt-6">
            <PrinterStatusMonitor />
          </TabsContent>

          <TabsContent value="settings" className="mt-6">
            <PrintingSettings />
          </TabsContent>
        </Tabs>
      </div>
    </SiteWrapper>
  );
};

export default PrintingPage;
